import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import LayoutComponent from '../components/layout/LayoutComponent.vue';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'HomePage',
    component: () => import(/* webpackChunkName: 'home-page' */ '../views/home/HomePage.vue')
  },
  {
    path: '/announcements',
    component: LayoutComponent,
    children: [
      {
        path: '',
        name: 'AnnouncementPage',
        component: () => import(/* webpackChunkName: 'announcement-page' */ '@/views/announcement/AnnouncementPage.vue')
      },
      {
        path: ':id',
        name: 'AnnouncementDetailPage',
        component: () => import(/* webpackChunkName: 'announcement-dateil-page' */ '@/views/announcement/detail/AnnouncementDetailPage.vue')
      }
    ]
  },
  {
    path: '/videos',
    component: LayoutComponent,
    children: [
      {
        path: '',
        name: 'VideoPage',
        component: () => import(/* webpackChunkName: 'video-page' */ '@/views/video/VideoPage.vue')
      },
      {
        path: ':id',
        name: 'VideoDetailPage',
        component: () => import(/* webpackChunkName: 'video-dateil-page' */ '@/views/video/detail/VideoDetailPage.vue')
      }
    ]
  },
  {
    path: '/project',
    component: LayoutComponent,
    children: [
      {
        path: '',
        name: 'ProjectPage',
        component: () => import(/* webpackChunkName: 'project-page' */ '@/views/project/ProjectPage.vue')
      }
    ]
  },
  {
    path: '/province',
    component: LayoutComponent,
    children: [
      {
        path: '',
        name: 'ProvincePage',
        component: () => import(/* webpackChunkName: 'province-page' */ '@/views/province/ProvincePage.vue')
      }
    ]
  },
  {
    path: '/psc',
    component: LayoutComponent,
    children: [
      {
        path: '',
        name: 'PscPage',
        component: () => import(/* webpackChunkName: 'psc-page' */ '@/views/psc/PscPage.vue')
      }
    ]
  },
  {
    path: '/documents',
    component: LayoutComponent,
    children: [
      {
        path: '',
        name: 'DocumentPage',
        component: () => import(/* webpackChunkName: 'document-page' */ '@/views/document/DocumentPage.vue')
      }
    ]
  },
  {
    path: '/others',
    component: LayoutComponent,
    children: [
      {
        path: '',
        name: 'OtherPage',
        component: () => import(/* webpackChunkName: 'other-page' */ '@/views/other/OtherPage.vue')
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFoundPage',
    component: () => import(/* webpackChunkName: 'notfound-page' */ '../views/notFound/NotFound.vue')
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
